import React from 'react';
import { TopCarouselWrapper, TopCarouselColumn } from './style';
import { BorderTitle, StyledLink, Text } from 'assets/GlobalLayoutStyle';

interface PROPS {
  link: string;
  img: string;
  title: string;
  description: string;
}

const CarouselItem: React.FC<PROPS> = ({ link, img, title, description }) => {
  return (
    <TopCarouselWrapper img={img}>
      <StyledLink to={link}>
        <TopCarouselColumn>
          <div>
            <BorderTitle min>{title}</BorderTitle>
            <div className="module-spacer--small" />
            <Text min left whiteShadow black>
              {description}
            </Text>
          </div>
        </TopCarouselColumn>
      </StyledLink>
    </TopCarouselWrapper>
  );
};

export default CarouselItem;
